import { TokenIcon } from "@tutellus/tutellus-components"
import cx from "classnames"
import styles from "./index.module.css"
import { RootDataLoader } from "../../../pages/DataRoot/loader"
import { useRouteLoaderData } from "react-router"

export type TokenNameCellProps = {
  tokenID: string
  size?: "small" | "default"
}

export const TokenNameCell = ({ tokenID, size = "default" }: TokenNameCellProps) => {
  const { projectConfig } = useRouteLoaderData("root") as RootDataLoader

  const tokenName =
    projectConfig.tokens.find((token) => token.id === tokenID)?.symbol ||
    projectConfig.pools.find((pool) => pool.id === tokenID)?.name ||
    tokenID

  const iconSize = size === "small" ? "l" : "2xl"

  return (
    <div className={cx(styles.tokenNameCellWrapper, { [styles.small]: size === "small" })}>
      <div className={styles.tokenNameCell}>
        <TokenIcon iconKey={tokenID} size={iconSize} />
        <p className={styles.tokenCellNameText}>{tokenName}</p>
      </div>
    </div>
  )
}
